"use client"

const Button = ({
  children,
  type = "button",
  variant = "primary",
  size = "md",
  className = "",
  disabled = false,
  onClick,
  ...props
}) => {
  const baseClasses = "font-medium rounded-lg focus:ring-4 focus:outline-none inline-flex items-center justify-center"

  const variantClasses = {
    primary: "text-white bg-blue-600 hover:bg-blue-700 focus:ring-blue-300 disabled:bg-blue-400",
    secondary:
      "text-gray-900 bg-white border border-gray-300 hover:bg-gray-100 focus:ring-gray-200 disabled:bg-gray-100",
    success: "text-white bg-green-600 hover:bg-green-700 focus:ring-green-300 disabled:bg-green-400",
    danger: "text-white bg-red-600 hover:bg-red-700 focus:ring-red-300 disabled:bg-red-400",
    warning: "text-white bg-yellow-500 hover:bg-yellow-600 focus:ring-yellow-300 disabled:bg-yellow-400",
  }

  const sizeClasses = {
    sm: "px-3 py-1.5 text-xs",
    md: "px-5 py-2.5 text-sm",
    lg: "px-6 py-3 text-base",
  }

  const classes = `${baseClasses} ${variantClasses[variant]} ${sizeClasses[size]} ${className} ${disabled ? "cursor-not-allowed" : ""}`

  return (
    <button type={type} className={classes} disabled={disabled} onClick={onClick} {...props}>
      {children}
    </button>
  )
}

export default Button
